module.exports = __webpack_public_path__ + "img/ecommerce-dashboard.675e88dd.jpg";